import { api, qs } from "./clientService";
import { MediaMTXBroadcastRequest, MediaMTXStopBroadcastRequest, MediaMTXUpdateBroadcastRequest } from "@/interface/requests/mediamtxbroadcastRequest";
import { MediaSoupBroadcastRequest, MediaSoupStopBroadcastRequest } from "@/interface/requests/mediasoupbroadcastRequest";

import { MediaMTXBroadcastResponse, MediaMTXStatusResponse, MediaMTXStopBroadcastResponse, MediaMTXUpdateBroadcastResponse } from "@/interface/responses/mediamtxbroadcastResponse";
import { MediaSoupBroadcastResponse, MediaSoupStopBroadcastResponse } from "@/interface/responses/mediasoupbroadcastResponse";



/**
 * POST /api/v1/stream/mediamtx/start-stream
 * Start a stream with multiple devices for MediaMTX.
 */
export function MediaMTXBroadcast(payload: MediaMTXBroadcastRequest) {
  return api<MediaMTXBroadcastResponse>(
    "/api/v1/stream/mediamtx/start-broadcast",
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  );
}


/**
 * PUT /api/v1/stream/mediamtx/update-broadcast/{streamId}
 * Update a MediaMTX broadcast
 */
export function MediaMTXUpdateBroadcast(streamId: number, payload: MediaMTXUpdateBroadcastRequest) {
  return api<MediaMTXUpdateBroadcastResponse>(
    `/api/v1/stream/mediamtx/update-broadcast/${streamId}`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
    }
  );
}

/**
 * POST /api/v1/stream/mediamtx/stop-broadcast
 * Stop a mediamtx broadcast and notify all devices.
 */
export function MediaMTXStopBroadcast(payload: MediaMTXStopBroadcastRequest) {
  return api<MediaMTXStopBroadcastResponse>(
    "/api/v1/stream/mediamtx/stop-broadcast",
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  );
}

/**
 * GET /api/v1/stream/mediamtx/status
 * Get MediaMTX broadcast status
 */
export function MediaMTXGetStatus() {
  return api<MediaMTXStatusResponse>(
    "/api/v1/stream/mediamtx/status",
    {
      method: "GET",
    }
  );
}

/**
 * POST /api/v1/stream/mediasoup/start-broadcast
 * Start a broadcast with producer IDs for MediaSoup.
 */
export function MediaSoupBroadcast(payload: MediaSoupBroadcastRequest) {
  return api<MediaSoupBroadcastResponse>(
    "/api/v1/stream/mediasoup/start-broadcast",
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  );
}

/**
 * POST /api/v1/stream/mediasoup/stop-broadcast
 * Stop a broadcast with device serials for MediaSoup.
 */
export function MediaSoupStopBroadcast(payload: MediaSoupStopBroadcastRequest) {
  return api<MediaSoupStopBroadcastResponse>(
    "/api/v1/stream/mediasoup/stop-broadcast",
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  );
}